import i18n from '@/utils/i18n';
import React from 'react';
import { APP_MODAL_ROUTES, ORDER_INBOUNDS_ROUTES } from '@/navigators/routes';
import {
  AppModalStackParams,
  OrderInboundsStackParams,
} from '@/navigators/types';
import { EditOrderItemNoteContent } from '@/components/orders/edit-order-item-note-content';
import { ModalContainer } from '@/components/modal-container';
import { SCREEN_PADDING } from '@/styles';
import { StackScreenProps } from '@react-navigation/stack';
import { useInterceptNavigationBeforeRemove } from '@/hooks/use-intercept-navigation-before-remove';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

type Props =
  | StackScreenProps<
      AppModalStackParams,
      APP_MODAL_ROUTES.EditOrderItemNoteModal
    >
  | StackScreenProps<
      OrderInboundsStackParams,
      ORDER_INBOUNDS_ROUTES.EditOrderItemNote
    >;

export const EditOrderItemNoteModalScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const { initialNotes, onNotesSaved, variantPackUUID } = route.params;
  const { bottom } = useSafeAreaInsets();
  const {
    invokeCloseHandler,
    markCloseConfirmedAndGoBack,
    registerCloseHandler,
  } = useInterceptNavigationBeforeRemove(navigation);

  return (
    <ModalContainer
      navigationHeaderProps={{
        centerTitle: true,
        onBackPress: invokeCloseHandler,
        showBackButton: true,
        title: i18n.t('item_note'),
      }}
      showLargeLayoutCloseButton={false}
    >
      <EditOrderItemNoteContent
        contentContainerStyle={{
          paddingBottom: Math.max(bottom, SCREEN_PADDING),
          paddingHorizontal: SCREEN_PADDING,
        }}
        initialNotes={initialNotes}
        onClose={markCloseConfirmedAndGoBack}
        onNotesSaved={onNotesSaved}
        onRegisterCloseHandler={registerCloseHandler}
        variantPackUUID={variantPackUUID}
      />
    </ModalContainer>
  );
};
